import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  closeIcon: {
    color: `${colors.brandBlue500} !important`,
  },
  chip: {
    borderRadius: "4px",
    backgroundColor: "#EDF5FB",
    color: colors.brandBlue500,
    fontFamily: "Manrope",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 600,
  },
}));

export default styles;
